import { Exercise as ComponentExercise } from "@/services/admin/exercises.interfaces";
import { LucideIcon } from "lucide-react";
import { ListChecks } from "lucide-react";
import { EditorInterface } from "./EditorInterface";
import { CardInfo } from "./types";

/**
 * Classe de informações para exercícios do tipo Separador de Seção
 */
export class StyledSectionEditor extends EditorInterface {
  /**
   * Retorna as informações para exibir no cartão do exercício
   * @param exercise Objeto do exercício
   */
  static GetCardInfo(exercise: ComponentExercise): CardInfo {
    const data = exercise.data as {
      title: string;
      description?: string;
    };
    
    return {
      title: data.title || 'Separador de Seção',
      subtitle: 'Separador visual',
      description: data.description || 'Separador de seção estilizado'
    };
  }
  
  /**
   * Retorna o título do tipo de exercício
   */
  static getTitle(): string {
    return 'Separador de Seção';
  }
  
  /**
   * Retorna uma descrição do exercício formatada para exibição
   * @param exercise Objeto do exercício
   */
  static getDescription(exercise: ComponentExercise): string {
    const data = exercise.data as {
      title: string;
      description?: string;
    };
    
    return data.title || 'Separador de seção';
  }
  
  /**
   * Retorna o ícone correspondente ao tipo do exercício
   */
  static getIcon(): LucideIcon {
    return ListChecks;
  }
} 